import requests from "./httpService";

const PageServices = {

    getSpotPrice: async (body) => {
        return requests.post(`/getSpot`, body);
    },
    getStraddleChart: async (symbolToken,minStrike,maxStrike) => {
        return requests.get(`/history/straddleChart?symbol=${symbolToken}&minStrike=${minStrike}&maxStrike=${maxStrike}`);
    },
    getOptionChain: async (body) => {
        console.log(body)
        return requests.post(`/getOptionGreeksChain`, body);
    },
    getServerInfo: async () => {
        return requests.get(`/market/optionchain/server-info`);
    },
    getComodityOptionChain: async (body) => {
        console.log(body)
        return requests.post(`/getComodityOptionChain`, body);
    },
    getHistorydata: async (body) => {
        console.log(">>>body", body)
        return requests.post(`/history/oldDataa`, body);
    },
    getHistoryOldData: async (body) => {
        console.log(">>>body", body)
        return requests.post(`/history/oldhistorydata`, body);
    },
    // OI Charts → OI Change: strike's CE / PE OI change per minute (millions) + support / resistance
    getOiChangeGraph: async (body) => {
        return requests.post(`/history/oiChangeGraph`, body);
    },
    // OI Charts → OI Graph: strike's CE / PE open interest per minute (millions) + support / resistance
    getOiGraph: async (body) => {
        return requests.post(`/history/oiGraph`, body);
    },
    // OI Charts popup: one tab's series for a strike (chart = oiChange | oi | voi | crossOi | pcr | ceBuildup | peBuildup | coiPct | volume)
    getStrikeCharts: async (body) => {
        return requests.post(`/history/strikeCharts`, body);
    },
    getOiStrikeGraph: async (body) => {
        return requests.post(`/history/oiStrikeGraph`, body);
    },
    getHistorydataOichg: async (body) => {
        console.log(body)
        return requests.post(`/history/oldceandpe`, body);
    },
    getExpirydate: async (symbolToken = localStorage.getItem('stock') || 'NIFTY') => {
        return requests.get(`/dates/expiry-dates?symbolToken=${encodeURIComponent(symbolToken)}`);
    },
    getSelectdate: async (expiryDate, symbolToken = localStorage.getItem('stock') || 'NIFTY') => {
        return requests.get(`/dates/select-dates?expiryDate=${encodeURIComponent(expiryDate)}&symbolToken=${encodeURIComponent(symbolToken)}`);
    },
    getOldData: async (body) => {
        return requests.post(`/history/oldData`, body);
    },
    getOldDataWithDate: async (body) => {
        return requests.post(`/history/oldDataWithDate`, body);
    },
    getOldSpot: async (body) => {
        return requests.post(`/history/oldSpot`, body);
    },

    getDataForSuportandRessitans: async (symbolToken) => {       // console.log(body)
        return requests.get(`/history/forSupportAndRessitance?symbolToken=${symbolToken}`);
    },
    getDataAverageSuportandRessitans: async (symbolToken, date) => {       // console.log(body)
        return requests.get(`/history/averageSupportAndRessitance?symbolToken=${symbolToken}&date=${date}`);
    },
    getStockDataSupportandResistance: async (date) => {
        console.log("date", date);
        return requests.get(`/history/stock/stockdata?date=${date}`);
    },
    getTripleSRStock: async (date) => {
        // console.log("date",date);
        return requests.get(`/history/stock/triplestockdata?date=${date}`);
    },
    getOptionSellingStocks: async (date) => {
        return requests.get(`/history/stock/option-selling?date=${date}`);
    },
    getTrendWithStocks: async (date) => {
        return requests.get(`/history/stock/trend-with-stocks?date=${date}`);
    },
    getHotStockData: async (date) => {
        return requests.get(`/history/stock/hotstockdata?date=${date}`);
    },
    getHotOptionData: async () => {
        return requests.get(`/tradingStock/hotStock`);
    },
    // Spot Chart popup: today's 1-minute spot candles
    // `date` / `time` (optional, Backtester): that day up to that time instead of the latest session
    getSpotCandles: async (symbolToken, interval = 1, date, time) => {
        const hist = date ? `&date=${encodeURIComponent(date)}${time ? `&time=${encodeURIComponent(time)}` : ''}` : '';
        return requests.get(`/spotCandles?symbolToken=${symbolToken}&interval=${interval}${hist}`);
    },
    // Power Stocks page: support / resistance power stocks of a day (default today)
    // Option chain Greeks Graph: per-minute Call / Put Greek totals (date optional)
    getGreeksGraph: async (symbolToken, date) => {
        return requests.get(`/history/greeksGraph?symbolToken=${encodeURIComponent(symbolToken)}${date ? `&date=${encodeURIComponent(date)}` : ''}`);
    },
    // Momentum Indicator → Vega tab (NIFTY / BANKNIFTY, date optional)
    getVegaTracker: async (symbolToken, date) => {
        return requests.get(`/vegaTracker?symbolToken=${encodeURIComponent(symbolToken)}${date ? `&date=${encodeURIComponent(date)}` : ''}`);
    },
    // Hot Stocks page (date optional)
    getHotStocks: async (date) => {
        return requests.get(`/hotStocks${date ? `?date=${encodeURIComponent(date)}` : ''}`);
    },
    getPowerStocks: async (date) => {
        return requests.get(`/powerStocks${date ? `?date=${encodeURIComponent(date)}` : ''}`);
    },
    // S/R Stocks page (date optional, DD-MMM-YYYY)
    getSrStocks: async (date) => {
        return requests.get(`/srStocks${date ? `?date=${encodeURIComponent(date)}` : ''}`);
    },
    getFutureAndSpotData: async (symbolToken, date, time) => {
        const hist = date ? `&date=${encodeURIComponent(date)}${time ? `&time=${encodeURIComponent(time)}` : ''}` : '';
        return requests.get(`/futurePrice/?symbolToken=${symbolToken}${hist}`);
    },
    getOIPercentageGraph: async (body) => {
        return requests.post(`/history/oiPercentageGraph`, body);
    },

}

export default PageServices;